import { render, staticRenderFns } from "./BigOccupationArea.vue?vue&type=template&id=6972309e"
import script from "./BigOccupationArea.vue?vue&type=script&lang=js"
export * from "./BigOccupationArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6972309e')) {
      api.createRecord('6972309e', component.options)
    } else {
      api.reload('6972309e', component.options)
    }
    module.hot.accept("./BigOccupationArea.vue?vue&type=template&id=6972309e", function () {
      api.rerender('6972309e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/BigOccupationArea.vue"
export default component.exports